<template>
	<div>/{{ value.data.src }}/{{ value.data.flags }}</div>
</template>

<script>
export default {
	name: 'ArgRegex',
	props: {value: Object},
}
</script>
